module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "my-4"
  }, [_vm._v("遊台灣學英語 功能清單")]), _vm._v(" "), _c('div', {
    staticClass: "my-5 list-box",
    staticStyle: {
      "min-height": "40vh"
    }
  }, [_c('div', {
    staticClass: "menu-box",
    on: {
      "click": function($event) {
        return _vm.goPage('Record.classList.tw')
      }
    }
  }, [_c('p', [_vm._v("觀看使用紀錄")]), _vm._v(" "), _c('p', [_vm._v("Using a record")])])]), _vm._v(" "), _c('div', {
    staticClass: "download-box px-4"
  }, [_c('a', {
    staticClass: "downloadLink",
    attrs: {
      "download": "LiveCampus 使用手冊",
      "href": _vm.sampleFile
    }
  }, [_vm._v("下載使用說明")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b392c30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/tw/TwIndex.vue
// module id = 766
// module chunks = 3